// extracted by mini-css-extract-plugin
export default {"std":"Headline_std__mIB4E","gray":"Headline_gray__roPqZ","grayDark":"Headline_grayDark__swZWk","error":"Headline_error__S3DBv"};